import axios from 'axios'
import store from '../store'
import router from '../router'

// 未设置 VUE_APP_API_BASE 时走当前站点 /api，由 vue.config.js 代理到本地 acca-admin-api。
// 生产构建在 .env.production 中设置 VUE_APP_API_BASE 为线上 API 根地址（无末尾 /）。
const apiBase = process.env.VUE_APP_API_BASE
const baseURL =
  apiBase && String(apiBase).trim() !== ''
    ? String(apiBase).trim().replace(/\/+$/, '')
    : '/'

const instance = axios.create({
  baseURL,
  timeout: 30000
})

instance.interceptors.request.use(config => {
  const t = store.state.token
  if (t) {
    config.headers.Authorization = `Bearer ${t}`
  }
  return config
})

instance.interceptors.response.use(
  res => res,
  err => {
    const status = err.response && err.response.status
    if (status === 401 || status === 403) {
      store.commit('clearAuth')
      if (router.currentRoute.path !== '/login') {
        router.replace('/login')
      }
    }
    if (!err.response) {
      const remoteBase =
        baseURL &&
        baseURL !== '/' &&
        !/^https?:\/\/(127\.0\.0\.1|localhost)(:\d+)?\/?$/i.test(baseURL)
      const hint = remoteBase
        ? '无法连接接口服务器，请检查网络或后端服务是否正常。'
        : '连不上后端：1) 终端执行 cd acca-admin-api && mvn spring-boot:run，控制台无报错且监听 18080（application.yml）；2) MySQL 已启动并已执行 schema.sql；' +
          '3) 浏览器打开地址与 npm run serve 一致（不要 localhost 与 127.0.0.1 混用）。' +
          '自检：先访问 /api/public/health 应返回 {"status":"UP"}。'
      return Promise.reject(new Error(hint))
    }
    const msg =
      (err.response.data && err.response.data.message) ||
      err.message ||
      '请求失败'
    return Promise.reject(new Error(msg))
  }
)

export default instance
